import { useContext } from 'react'

import { ADD_ROOM, REMOVE_ROOM } from '../../Constants'
import { LinkLayover } from './LinkLayover'
import { PAXContext } from './PaxContext'

/**
 * Footer Componet for Room
 * Remove Room and Add Room operation will perform here
 */
export default function RoomFooter() {
	const [{ enableRoomAdition = true, costingInfo = [] }, dispatch] =
		useContext(PAXContext)
	return (
		<LinkLayover
			links={[
				{
					text: 'Delete room',
					iconClassName: 'pyt-delete-16',
					onClickAction: () => {
						if (costingInfo.length > 1) {
							dispatch({
								type: REMOVE_ROOM,
								payload: {},
							})
						}
					},
					isHide: costingInfo.length === 1,
					textColor: '#F15F75',
				},
				{
					text: 'Add room',
					iconClassName: 'pyt-plus-16',
					onClickAction: () => {
						if (enableRoomAdition) {
							dispatch({
								type: ADD_ROOM,
								payload: {
									adultCount: 1,
									childAges: [],
								},
							})
						}
					},
					isDisabled: !enableRoomAdition,
					textColor: '#148099',
				},
			]}
		/>
	)
}
